import { Route, Routes } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'
import { FormulariosListWrapper } from './formularios-list/FormulariosList'
import { FormularioCreateWrapper } from './formularios-create/FormularioCreate'
import { EspecialidadeVinculosListWrapper } from './vinculos-especialidade-list/EspecialidadeVinculosList'
import { TiposAtendimentoVinculosListWrapper } from './vinculos-tipo-atendimento-list/TiposAtendimentoVinculosList'
import { QueryRequestProvider } from './formularios-list/core/QueryRequestProvider'
import { ListFiltersProvider } from './formularios-list/core/ListFiltersProvider'

const apiBreadcrumbs: Array<PageLink> = [
  {
    title: 'Formulários',
    path: '/apps/formularios',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const FormulariosPage = () => {
  const { t } = useT()
  // Estado da listagem acima das rotas: ao voltar da edição, a lista reabre na mesma página,
  // com os mesmos filtros e ordenação.
  return (
    <QueryRequestProvider>
      <ListFiltersProvider>
        <Routes>
          <Route
            path=''
            element={
              <>
                <PageTitle description={t('pagina.formulario.descricao')}>
                  {t('formulario.plural')}
                </PageTitle>
                <FormulariosListWrapper />
              </>
            }
          />
          <Route
            path='criar'
            element={
              <>
                <PageTitle breadcrumbs={apiBreadcrumbs}>Novo Formulário</PageTitle>
                <FormularioCreateWrapper />
              </>
            }
          />
          <Route
            path='editar'
            element={
              <>
                <PageTitle breadcrumbs={apiBreadcrumbs}>Editar Formulário</PageTitle>
                <FormularioCreateWrapper />
              </>
            }
          />
          <Route
            path='vinculos/especialidade/:id'
            element={
              <>
                <PageTitle breadcrumbs={apiBreadcrumbs}>Vínculos por Especialidade</PageTitle>
                <EspecialidadeVinculosListWrapper />
              </>
            }
          />
          <Route
            path='vinculos/tipoAtendimento/:id'
            element={
              <>
                <PageTitle breadcrumbs={apiBreadcrumbs}>
                  Vínculos por tipos de atendimento
                </PageTitle>
                <TiposAtendimentoVinculosListWrapper />
              </>
            }
          />
        </Routes>
      </ListFiltersProvider>
    </QueryRequestProvider>
  )
}

export default FormulariosPage
